import React from "react";
import CambiarPassword from "./CambiarPassword";

const WrapperStyles = ({ children }) => {
    return (
        <div
            style={{
                backgroundColor: "#fafafa",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                height: "100vh",
                width: "100vw",
                marginBottom: 0,
                marginTop: 0,
            }}
        >
            {children}
        </div>
    );
};

function CambiarPasswordExterna() {
    return (
        <WrapperStyles>
            <CambiarPassword
                permitirDeshabilitarPermisos={true}
                tituloFormulario="Cambiar Password"
            />
        </WrapperStyles>
    );
}

export default CambiarPasswordExterna;
